<template>
  <div class="font3">
      <div style="height:75vh;overflow-y:scroll;overflow-x:hidden">
                  <div>
                  
                       <v-card  v-for="i in item" :key="i.item" class="pa-3 ma-4"  flat active-class="grey ">
                       <p class="font-weight-bold mb-n1 text-caption">{{i.properties.PROPERTY_NAME_TEXT}}</p>
                       <p class=" text-caption mb-n1">{{i.properties.ADDRESS_LINE1_TEXT}}, {{i.properties.STD_CITY}},{{i.properties.STD_ST}} {{i.properties.STD_ZIP5}}</p>
                       <p class="text-caption ">{{i.properties.PROPERTY_ON_SITE_PHONE_NUMBER}}</p>
                      
                       
                       <div>
                           <v-icon style="opacity:0.4" size="30">mdi-bank-check</v-icon>
                           <p class="text-caption grey--text">Available</p>
                       </div>
                       <v-row no-gutters dense>
                           
                           <v-divider class="ml-2 mr-2" style="opacity:0.4"></v-divider>
                          
                       </v-row>
                   </v-card>
                  </div>
                        </div>
  </div>
</template>

<script>

export default {
    props:['item','select'],
    data(){
        return {
        
        }
    },
    mounted(){
        setInterval(()=>{
            for(var i=0;i<this.item.length;i++){
                if(this.item[i].properties.PROPERTY_NAME_TEXT==this.select){
                    this.item=[...this.item[i]]
                }
            }
        },1000)
    }
    
}
</script>

<style>
.font3{
    font-family: 'Ubuntu', sans-serif;
}
</style>